let swRegistration = null;
let onUpdateCallback = null;
let onSuccessCallback = null;
let pendingUpdateRegistration = null;

export function getRegistration() {
  return swRegistration;
}

export function onUpdate(callback) {
  onUpdateCallback = callback;
  // A waiting worker found before the UI subscribed is reported now
  if (callback && pendingUpdateRegistration) {
    const reg = pendingUpdateRegistration;
    pendingUpdateRegistration = null;
    callback(reg);
  }
}

function notifyUpdate(registration) {
  if (onUpdateCallback) onUpdateCallback(registration);
  else pendingUpdateRegistration = registration;
}

export function onSuccess(callback) {
  onSuccessCallback = callback;
}

export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });
      swRegistration = registration;

      // A worker already waiting (e.g. the user dismissed the banner earlier)
      if (registration.waiting && navigator.serviceWorker.controller) {
        notifyUpdate(registration);
      }

      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New version installed and waiting: show the banner, never reload
              notifyUpdate(registration);
            } else {
              // First install: content is cached for offline use, nothing to do
              if (onSuccessCallback) onSuccessCallback(registration);
            }
          }
        });
      });

      // Poll for updates every 5 minutes (saves battery & data)
      setInterval(() => {
        registration.update().catch(() => {});
      }, 300000);

    } catch (err) {
      console.error('SW registration failed:', err);
    }
  });

  // When a new SW takes over, do NOT auto-reload here. UpdateNotification
  // shows a non-blocking banner and reloads only after the user clicks it.
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

export function skipWaiting() {
  if (swRegistration?.waiting) {
    swRegistration.waiting.postMessage('SKIP_WAITING');
  }
}
